import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-admin',
  templateUrl: './admin.component.html',
  styleUrls: ['./admin.component.less'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class AdminComponent implements OnInit {
  constructor(
    private route: Router,
    private activeRoute: ActivatedRoute
  ) {}

  ngOnInit(): void {}
}
